'use strict';

import mergeOpts from './merge-opts';

const timeouts = new Map();

export default function debounce(callback, opts) {
    opts = mergeOpts({
        delay: 200,
    }, opts);

    return function () {
        let timeoutId = timeouts.get(callback);
        clearTimeout(timeoutId);

        const self = this;
        const args = arguments;
        timeoutId = setTimeout(function () {
            callback.apply(self, args);
        }, opts.delay);

        timeouts.set(callback, timeoutId);
    };
}
